<div class="button-group-input-container" [ngClass]="'button-group-style-' + style" [class.button-group-disabled]="disabled">
  <ng-container *ngFor="let optionItem of options">
    <div class="button-group-item" [class.button-item-disabled]="disabled || (optionItem.disabled !== undefined && optionItem.disabled())" (click)="onSelectOption(optionItem)" [class.item-selected]="_value === optionItem.value" [class.has-border-bottom]="optionItem.color" [style.border-bottom-color]="optionItem.color" [tooltip]="optionItem.tooltip" [class.consistent-widths]="consistentWidths">
      <span *ngIf="optionItem.iconClasses" class="fal fa-fw m-right-5" [ngClass]="optionItem.iconClasses"></span>
      <span translate>{{optionItem.friendlyText}}</span>
    </div>
  </ng-container>
</div>
